import { Component, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FacilityService } from "../../service/facility.service";
import { Constant } from "../../commons/Constants";
import { AppService } from "../../service/app.service";

@Component({
  selector: "app-facility",
  templateUrl: "./facility.component.html",
  styleUrls: ["./facility.component.scss"],
})
export class FacilityComponent implements OnInit {
  public isMobile = false;
  public selectedCategory = "";
  public selectedLang: number = 0;

  private groupedFacilities: any;
  public categories: string[] = [];
  public rows: { col1?: any; col2?: any }[] = [];

  constructor(
    private router: Router,
    private facilityService: FacilityService,
    private appService: AppService
  ) {}

  @HostListener("window:resize", ["$event"])
  onResize(): void {
    this.checkScreenSize();
  }

  public ngOnInit(): void {
    this.checkScreenSize();
    this.handleLangChange();
    this.loadFacilities();
  }

  public checkScreenSize(): void {
    this.isMobile = window.innerWidth < 768;
  }

  private handleLangChange(): void {
    this.appService.selectedLangListener.subscribe({
      next: (lang: number) => {
        this.selectedLang = lang ?? 0;
        this.setupDisplayData();
      },
    });
  }

  public loadFacilities(): void {
    this.facilityService.getAllFacilitiesWithArea().subscribe({
      next: (res) => {
        if (res.status === Constant.HTTP_200) {
          this.groupedFacilities = this.groupFacilitiesByArea(res.data);
          this.setupDisplayData();
        }
      },
      error: (err) => console.log(err),
    });
  }

  public moveToTop() {
    this.router.navigate(["carry-reserve"]).then(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  public selectCategory(category: string): void {
    this.selectedCategory = this.selectedCategory === category ? "" : category;
  }

  public filteredItemsByCategory(
    category: string
  ): Array<{ name: string; nameEnglish: string }> {
    const cleanCategory = category;
    const targetGroup = this.groupedFacilities.find(
      (group: any) =>
        (this.selectedLang === 0 ? group.areaName : group.areaNameEnglish) ===
        cleanCategory
    );
    return targetGroup ? targetGroup.facilities : [];
  }

  private groupFacilitiesByArea(facilities: any): any {
    const grouped = new Map<string, any>();

    facilities.forEach((facility: any) => {
      const areaKey =
        this.selectedLang === 0 ? facility.areaName : facility.areaNameEnglish;

      if (!grouped.has(areaKey)) {
        grouped.set(areaKey, {
          areaName: facility.areaName,
          areaNameEnglish: facility.areaNameEnglish,
          facilities: [],
          isExpanded: false,
        });
      }

      grouped.get(areaKey)!.facilities.push({
        name: facility.stayFacilityName,
        nameEnglish: facility.stayFacilityNameEnglish,
      });
    });

    return Array.from(grouped.values());
  }

  private setupDisplayData(): void {
    if (!this.groupedFacilities) return;

    this.categories = this.groupedFacilities.map((group: any) =>
      this.selectedLang === 0 ? group.areaName : group.areaNameEnglish
    );

    const flatList: Array<{ text: string; isArea: boolean }> = [];

    this.groupedFacilities.forEach((group: any) => {
      const areaName =
        this.selectedLang === 0 ? group.areaName : group.areaNameEnglish;

      flatList.push({ text: areaName, isArea: true });

      group.facilities.forEach((facility: any) => {
        const facilityName =
          this.selectedLang === 0 ? facility.name : facility.nameEnglish;
        flatList.push({ text: facilityName, isArea: false });
      });
    });

    const mid = Math.ceil(flatList.length / 2);
    const col1 = flatList.slice(0, mid);
    const col2 = flatList.slice(mid);

    this.rows = [];
    for (let i = 0; i < Math.max(col1.length, col2.length); i++) {
      this.rows.push({
        col1: col1[i],
        col2: col2[i],
      });
    }
  }
}
